
export const serverAppConfig = {
  "storeId": "6388a4653f9649df920f8ebd",
  "categories": [
    {
      "id": "6464c0941c6b847ac244038b",
      "name": "Produkter",
      "slug": "produkter",
      "description": "Upptäck våra högkvalitativa vinkylar från Vigneron i storlekarna 30 cm, 40 cm och 60 cm. Perfekta att bygga in under bänk, i högskåp eller som del av ett vinlagringsskåp.\n\nVåra vinkylar finns med singelzon och dubbelzon, i elegant svart, rostfritt stål eller med integrerad lucka som smälter in i köket.\nKontakta oss idag för personlig service och rådgivning, så hjälper vi dig att hitta rätt vinkyl för just ditt kök eller köksö.",
      "thumbnailDescription": "",
      "additionalText": "",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/produkter5ar.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/1313.png",
      "order": 1,
      "metaTitle": "",
      "metaDescription": "",
      "metaHeader": null,
      "subCategories": [
        {
          "id": "6464c09e1c6b847ac244038d",
          "name": "Under bänk",
          "slug": "produkter-vinkyl-under-bank",
          "description": "Letar du efter en vinkyl för inbyggnad? Här hittar du ett stort urval av vinkylar som passar perfekt under bänkskivor eller i bänkskåp. En integrerad vinkyl smälter sömlöst in i din köksdesign och skapar ett stilrent och modernt uttryck. Utforska vårt breda sortiment med modeller i olika storlekar, färger och funktioner – allt för att möta dina behov och förhöja vinförvaringen i ditt hem.",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/underbank16.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/1212.png",
          "order": 1,
          "metaTitle": "",
          "metaDescription": "",
          "metaHeader": null,
          "subCategories": [
            {
              "id": "6777dcd2314a432bac1bc331",
              "name": "Vinkyl 30cm",
              "slug": "produkter-under-bank-vinkyl-30cm",
              "description": "Letar du efter en vinkyl för inbyggnad? Här hittar du ett stort urval av vinkylar, inklusive smala modeller som vinkyl 30 cm, perfekt för mindre utrymmen under bänkskivor eller i bänkskåp. En integrerad vinkyl smälter sömlöst in i din köksdesign och skapar ett stilrent och modernt uttryck. Utforska vårt breda sortiment med olika storlekar, färger och funktioner – allt för att möta dina behov och förhöja vinförvaringen i ditt hem.",
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 2.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/VKC30DB copy.jpg",
              "order": 1,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6777dcd8fdf9317872b9cb6e",
              "name": "Vinkyl 40cm",
              "slug": "produkter-under-bank-vinkyl-40cm",
              "description": "Letar du efter en vinkyl för inbyggnad? Här hittar du ett stort urval av vinkylar, inklusive smala modeller som vinkyl 40 cm, perfekt för mindre utrymmen under bänkskivor eller i bänkskåp. En integrerad vinkyl smälter sömlöst in i din köksdesign och skapar ett stilrent och modernt uttryck. Utforska vårt breda sortiment med olika storlekar, färger och funktioner – allt för att möta dina behov och förhöja vinförvaringen i ditt hem.",
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 3.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/VKC40DS-2 copy.jpg",
              "order": 2,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "6777dcdfdc44144a9b3c47f4",
              "name": "Vinkyl 60cm",
              "slug": "produkter-under-bank-vinkyl-60cm",
              "description": "Letar du efter en vinkyl för inbyggnad? Här hittar du ett stort urval av vinkylar, inklusive smala modeller som vinkyl 60 cm, perfekt för mindre utrymmen under bänkskivor eller i bänkskåp. En integrerad vinkyl smälter sömlöst in i din köksdesign och skapar ett stilrent och modernt uttryck. Utforska vårt breda sortiment med olika storlekar, färger och funktioner – allt för att möta dina behov och förhöja vinförvaringen i ditt hem.",
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 1.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/VKC60DS-2 copy.jpg",
              "order": 3,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            }
          ]
        },
        {
          "id": "6464c0b01c6b847ac244038e",
          "name": "Fristående vinkyl",
          "slug": "produkter-fristaende-vinkyl",
          "description": "Våra fristående vinkylar från Vigneron finns i olika storlekar och färger, rymmer 50–300 flaskor och passar alla hem och vinkällare. Hitta din perfekta kyl och kontakta oss.",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/banenrsvin4.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/VS170DB - Marble Kitchen.jpg",
          "order": 5,
          "metaTitle": "",
          "metaDescription": "",
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6464c0c31c6b847ac2440391",
          "name": "Inbyggda i skåp",
          "slug": "produkter-vinkyl-inbyggda-i-skap",
          "description": "En inbyggd vinkyl i ett högskåp är både ett stilrent och funktionellt val för vinälskare. Med en högskåpslösning garanteras perfekt förvaring av dina viner vid rätt temperatur och fuktighet, vilket säkerställer optimal smak och kvalitet. Utforska vårt breda sortiment av vinkylar för inbyggnad i högskåp – välj mellan olika storlekar, stilar och funktioner för att skapa den perfekta vinförvaringen i ditt kök.",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/5arbuilt.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/built14.png",
          "order": 2,
          "metaTitle": "",
          "metaDescription": "",
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6464c0ce1c6b847ac2440393",
          "name": "Integrerad vinkyl",
          "slug": "produkter-integrerad-vinkyl",
          "description": "Upptäck Vignerons integrerade vinkylar – perfekt för ett stilrent kök med integrerad lucka. Optimal temperatur och elegant design för alla vinälskare. Kontakta oss för råd.",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/bannerjanapidi.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/mobilen5ar.png",
          "order": 3,
          "metaTitle": "",
          "metaDescription": "",
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6464c0dd1c6b847ac2440395",
          "name": "Vinlagringsskåp",
          "slug": "produkter-vinlagringsskap",
          "description": "Upptäck Vignerons vinlagringsskåp i svart och rostfritt stål – plats för 50–300 flaskor. Perfekt för seriös vinlagring hemma. Kontakta oss för mer information.",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/storage5ar.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/storage5.png",
          "order": 4,
          "metaTitle": "",
          "metaDescription": "",
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6464c0eb1c6b847ac2440396",
          "name": "Tillbehör",
          "slug": "produkter-tillbehor",
          "description": "",
          "thumbnailDescription": "",
          "additionalText": "",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/6 (5).jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/6 (5).jpg",
          "order": 7,
          "metaTitle": "",
          "metaDescription": "",
          "metaHeader": null,
          "subCategories": [
            {
              "id": "67a3321b7843e34ef08952a5",
              "name": "Hyllor",
              "slug": "produkter-tillbehor-hyllor",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/THECHAMPAGNESOMMELIER-11.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/THECHAMPAGNESOMMELIER-11.jpg",
              "order": 1,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "67a332296af18110b1c669c6",
              "name": "Vintillbehör",
              "slug": "produkter-tillbehor-vintillbehor",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/THECHAMPAGNESOMMELIER-07.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/THECHAMPAGNESOMMELIER-07.jpg",
              "order": 3,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "67f52491b8a3c94b4fe41c66",
              "name": "Ramlist",
              "slug": "produkter-tillbehor-ramlist",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/VKI45.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/VKI45.jpg",
              "order": 2,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            }
          ]
        },
        {
          "id": "673df8287801a753eea97753",
          "name": "Richard Juhlin by Vigneron",
          "slug": "produkter-richard-juhlin-by-vigneron",
          "description": "Richard Juhlin by Vigneron erbjuder exklusiva champagnehyllor för vinkylar och vinlagringsskåp. Stilren design och säker förvaring av ditt bubbel. Kontakta oss för mer information.",
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Photoshoot-2456.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Photoshoot-38.jpg",
          "order": 6,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        }
      ]
    },
    {
      "id": "6464c1a41c6b847ac244039d",
      "name": "Våra ambassadörer",
      "slug": "vara-ambassadorer",
      "description": "",
      "thumbnailDescription": "",
      "additionalText": "",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/bannerpartners.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Photoshoot-37.jpg",
      "order": 3,
      "metaTitle": "",
      "metaDescription": "",
      "metaHeader": null,
      "subCategories": null
    },
    {
      "id": "650ab87b440fc03d630ca711",
      "name": "Inspiration",
      "slug": "inspiration",
      "description": "Få inspiration för vinkylar, vinlagringsskåp och vinväggar för hem, hotell och restauranger. Stilrena lösningar som passar alla kök och miljöer.",
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Vigneron - header 1-textny.jpg",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/poggen-pohl-vigneron-27.jpg",
      "order": 4,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": [
        {
          "id": "650ab897440fc03d630ca712",
          "name": "Artiklar",
          "slug": "inspiration-artiklar",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Vigneron - header 1-textny.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/bastitest.png",
          "order": 3,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "650ab8a5440fc03d630ca715",
          "name": "Filmer",
          "slug": "inspiration-filmer",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 1.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/THECHAMPAGNESOMMELIER-16.jpg",
          "order": 6,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "650ab8af440fc03d630ca717",
          "name": "Miljöbilder",
          "slug": "inspiration-miljobilder",
          "description": "Utforska miljöbilder från Vigneron och se vinkylar, vinlagringsskåp och vinväggar i hem, hotell och restauranger. Få idéer för ditt kök eller din vinkällare.",
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Vigneron - header 1-text.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/7-VKB60SS.png",
          "order": 2,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "650ab8bb440fc03d630ca718",
          "name": "Stylingtips",
          "slug": "inspiration-stylingtips",
          "description": "Upptäck Vignerons stylingtips och miljöinspiration för vinkylar, vinlagringsskåp och vinväggar. Designa din vinkyl efter din samling och skapa ett hem, hotell eller restaurang med stil.",
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Gen-2--087.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Gen-2--087.jpg",
          "order": 4,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "65152344440fc03d630ca787",
          "name": "Samarbeten",
          "slug": "inspiration-samarbeten",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Photoshoot-10.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Photoshoot-24.jpg",
          "order": 5,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6603f446f636336ffb6e28c7",
          "name": "Vinvägg",
          "slug": "inspiration-vinvagg",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/testvinbanner.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/bdf4fce3-053c-43cd-90a0-904b17cdaad8.jpeg",
          "order": 1,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        }
      ]
    },
    {
      "id": "6745d781c362835cc4e4c1cb",
      "name": "Hotell & Restaurang",
      "slug": "hotell-restaurang",
      "description": "Vinkyl till hotell & Restaurang\nVigneron är det perfekta valet för hotell och restauranger tack vare sina produkter av högsta kvalitet, utrustade med de bästa komponenterna på marknaden. Våra vinskåp klarar frekvent användning och öppning, och alla modeller har utdragbara hyllor som gör det enkelt att hitta rätt flaska snabbt och effektivt.\n",
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": null,
      "thumbnailUrl": null,
      "order": 2,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": null
    },
    {
      "id": "6826ee81aab7e32628bc96b2",
      "name": "Utförsäljning",
      "slug": "utforsaljning",
      "description": "Välkommen till vår utförsäljning av Vigneron-skåp! Här hittar du allt från demoexemplar till utgående modeller – alla till riktigt bra priser. Passa på att fynda premiumskåp för vinförvaring innan de försvinner för gott.",
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 3.jpg",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/VKC60DS - Beige kitchen.jpg",
      "order": 5,
      "metaTitle": "Utförsäljning – Vigneron skåp till kanonpriser",
      "metaDescription": "Upptäck vår utförsäljning av Vigneron-skåp till oslagbara priser. Begränsat parti – först till kvarn!",
      "metaHeader": "Utförsäljning av Vigneron – Passa på innan de försvinner!",
      "subCategories": null
    }
  ],
  "assistant": {
    "id": null,
    "name": null,
    "imgUrl": null,
    "company": "Vigneron"
  },
  "storeType": "B2C",
  "storeDeliveries": [
    {
      "id": "644b8642252ffe45ced476b4",
      "name": "Delivery 1",
      "label": "1 - 3 dagar",
      "buyable": true
    },
    {
      "id": "6819ec14ebbcb0618a30f001",
      "name": "Delivery 2",
      "label": "Ej i lager",
      "buyable": true
    },
    {
      "id": "6825f1561768d2605faf703a",
      "name": "Delivery 3",
      "label": "5 - 8 dagar",
      "buyable": true
    },
    {
      "id": "6825f16e1768d2605faf703b",
      "name": "Delivery 4",
      "label": "1 - 2 veckor",
      "buyable": true
    },
    {
      "id": "6825f1841768d2605faf703c",
      "name": "Delivery 5",
      "label": "3 - 4 veckor",
      "buyable": true
    },
    {
      "id": "6825f1941768d2605faf703d",
      "name": "Delivery 6",
      "label": "1 - 2 månader",
      "buyable": true
    },
    {
      "id": "6825f1a81768d2605faf703e",
      "name": "Delivery 7",
      "label": "3 + månader",
      "buyable": true
    }
  ],
  "language": "sv",
  "currency": "SEK",
  "labels": {
    "currency": "SEK",
    "priceCurrency": "SEK"
  },
  "paths": {
    "brandsUrlPath": "/varumarken",
    "categoriesUrlPath": "/kategorier",
    "tagsUrlPath": "/t",
    "productsUrlPath": "/produkter",
    "blogsUrlPath": "/blogg"
  },
  "staticLinks": [
    {
      "id": "blog",
      "label": "Blogg",
      "path": "/blog"
    }
  ],
  "logoUrl": "https://storage.googleapis.com/gecko-media/EC_1033/store/Vigneron%20-%20Experience%20-%20Black.png",
  "showCart": true,
  "sortingOptions": [
    {
      "sortBy": "price",
      "sortOrder": "DESC",
      "sortLabel": "Pris högt-lågt",
      "default": false
    },
    {
      "sortBy": "price",
      "sortOrder": "ASC",
      "sortLabel": "Pris lågt-högt",
      "default": true
    },
    {
      "sortBy": "created",
      "sortOrder": "DESC",
      "sortLabel": "Nyaste",
      "default": false
    }
  ],
  "desktopItemHeight": "20vw",
  "mobileItemHeight": "75vw",
  "maxContentWidth": 1270,
  "menuMaxContentWidth": 1270,
  "sliderDefaultValues": [
    0,
    200000
  ],
  "freeShippingOver": 499,
  "shippingProviderConfig": {
    "provider": "DEFAULT",
    "simpleShipping": {
      "minimumOrderAmountForFreeDelivery": 499,
      "deliveryFee": 139
    }
  },
  "paymentProviderConfig": {
    "providerName": "KLARNA",
    "providerOptions": {
      "klarna": {
        "purchaseCountry": "SE",
        "availableCountries": null,
        "purchaseCurrency": "SEK",
        "phoneMandatory": true,
        "colorButton": null,
        "termsUrl": "/kopvillkor",
        "cancellationTermsUrl": "/kopvillkor#angerratt"
      }
    }
  },
  "filtersBeforeShowMore": 3,
  "sliderMaxPrice": 200000,
  "topNavHeight": {
    "panel": {
      "base": 0,
      "sm": "5vh"
    },
    "content": {
      "base": "8vh",
      "sm": "14vh"
    },
    "spacer": {
      "base": "8vh",
      "sm": "19vh"
    },
    "hero": {
      "base": "92vh",
      "sm": "81vh",
      "md": "60vh"
    }
  },
  "topNavSlideOutFeaturedCategories": 3,
  "socialMediaItems": [
    {
      "label": "Facebook",
      "icon": "FACEBOOK",
      "href": "https://www.facebook.com/Vigneron.se/"
    },
    {
      "label": "Instagram",
      "icon": "INSTAGRAM",
      "href": "https://www.instagram.com/vigneron_experience"
    }
  ],
  "topNavPanel": {
    "items": [
      {
        "label": "Om oss",
        "icon": "FaCrown",
        "href": "/om-vigneron"
      },
      {
        "label": "Kontakta oss",
        "icon": "FaRegStar",
        "href": "/kontakta-oss"
      },
      {
        "label": "Våra återförsäljare",
        "icon": "CiGlobe",
        "href": "/aterforsaljare"
      }
    ]
  },
  "menuCategoriesConfig": {
    "desktop": {},
    "mobile": {}
  },
  "footerConfig": {},
  "aihub": {
    "showOnMobile": false
  },
  "searchProductList": {},
  "fonts": {},
  "vatToggle": {
    "enabled": false
  },
  "quantityDiscountDisplay": {}
};
export const serverTheme = {}; 
